import { gql } from '@apollo/client';

export const GET_SH_STRUCTURE_SLOTS = gql`
  query GetShStructureSlots($structureId: ID!, $day: Date!, $sportType: String) {
    MDB {
      id
      _SH_ {
        id
        structureSlots(structureId: $structureId, day: $day, sportType: $sportType) {
          structureId
          day
          unionDurationSlots {
            key
            dayOffset
            time
          }
          fieldSlots {
            fieldId
            durationMinutes
            stepMinutes
            durationSlots {
              key
              dayOffset
              time
            }
          }
        }
      }
    }
  }
`;
